import { CORE_SYMBOL_MAP } from '../constants'

export default function mapCoreSymbol(symbol: string | undefined): string {
  return CORE_SYMBOL_MAP[symbol ?? 'undefined'] || symbol || 'undefined'
}
